'use client';

import dynamic from 'next/dynamic';
import { useSelectedLayoutSegment } from 'next/navigation';
import ClubShell from './ClubShell';

// A dynamic import on purpose: a static one would put the whole app shell — and every
// module its providers reach — into the bundle of every club website, which is where
// this split came from. It still renders on the server, so app pages hydrate as before.
const AppShell = dynamic(() => import('./AppShell'));

/**
 * Which shell a page runs inside. The segment, not the pathname: club pages are reached
 * through a subdomain rewrite, so the browser's path ("/training") and the server's
 * ("/c/club/training") differ, while the matched route segment is the same on both
 * sides of hydration.
 */
export function RootShell({ children }: { children: React.ReactNode }) {
    const clubSite = useSelectedLayoutSegment() === 'c';

    return clubSite ? <ClubShell>{children}</ClubShell> : <AppShell>{children}</AppShell>;
}
